import { Injectable } from '@angular/core';
import { FirestoreService } from './firestore/firestore.service';
import { Observable } from 'rxjs/Observable';
import { Globals } from '../globals';

export interface KeyPerson {
  active: boolean;
  createdAt: any;
  customerId: string;
  email: string;
  job: string;
  lastName: string;
  name: string;
  phone: string;
  supplierId: string;
  updatedAt: any;
}
interface KeyPersonId extends KeyPerson {
  id: string;
}

@Injectable()
export class KeyPersonsService {

  keyPersons$: Observable<any[]>;

  collection: string;

  constructor(
    private afh: FirestoreService,
  ) {
    this.collection = Globals.KEY_PERSONS_COLLECTION;
  }

  getKeyPersons(customerSupplierId: string, customerOrSupplier: string) {
    this.keyPersons$ = this.afh.colWithIds$(this.collection, ref => {
      return ref.where(customerOrSupplier, '==', customerSupplierId).where('active', '==', true) ;
    }).map(documents => {
      return documents.map(document => {
        const data = {
          id: document.id,
          name: document.name + " " + document.lastName,
          job: document.job,
          email: document.email
        }
        return data;
      })
    })
    return this.keyPersons$;
  }
  getKeyPerson(keyPersonId: string){
    return this.afh.docWithIds$(`${this.collection}/${keyPersonId}`);
  }

  addKeyPerson(keyPerson: any) {
    return this.afh.add(this.collection, keyPerson);
  }
  updateKeyPerson(id: string, keyPerson: any) {
    this.afh.update(`${this.collection}/${id}`, keyPerson);
  }
  deleteKeyPerson(id: string){
    this.afh.delete(`${this.collection}/${id}`);
  }

}

/* class KEY_PERSON{
  active: boolean;
  createdAt: any;
  customerId: string;
  email: string;
  job: string;
  lastName: string;
  name: string;
  phone: string;
  supplierId: string;
  updatedAt: any;
  constructor(customerDescription, name, job, phone, email){
    this.active = true;
    this.createdAt = new Date();
    this.customerId = '';//JSON.parse(localStorage.customersJson)[customerDescription] || '';
    this.email = email;
    this.job = job;
    this.lastName = '';
    this.name = name;
    this.phone = phone;
    this.supplierId = JSON.parse(localStorage.suppliersJson)[customerDescription];
    this.updatedAt = this.createdAt;
  }
} */